import React, { useState, useEffect, useCallback } from "react";
import { FaPen, FaTrash, FaTimes } from "react-icons/fa";
import "./WorkLocationList.css";
import Header from "../../layouts/Employee/Header";
import SubHeader from "../../layouts/Admin/SubHeader";
import WorkLocationListLayout from "../../layouts/Admin/WorkLocationListLayout";

const WorkLocationList = () => {
  return (
    <>
      <Header />
      <SubHeader />
      <WorkLocationListLayout />
    </>
  );
};

export default WorkLocationList;
